module.exports = __webpack_public_path__ + "img/online-payment.3a851df9.png";